import React, { useEffect, useMemo, useState } from "react";
import "./style.scss";
import {
  Box,
  Button,
  Card,
  FormControl,
  FormControlLabel,
  Grid,
  InputAdornment,
  ListSubheader,
  MenuItem,
  Modal,
  Radio,
  RadioGroup,
  Select,
  Tab,
  Tabs,
  TextField,
  Typography,
  styled,
} from "@mui/material";
import StyledFilledButton from "../../components/ReusableComponents/Button";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import crossIcon from "../../assets/images/crossIcon.svg";
import cautionIcon from "../../assets/images/cautionIcon.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  getPayoutVerificationStatus,
  updatePaymentVerification,
} from "../../store/reducers/payoutReducer";
import CombinedPopup from "../../components/Popups/CombinedPopup";

const BankWireModal = (props) => {
  const {
    open,
    modalClose,
    country,
    city,
    handleSelectChange,
    contryCodeArray,
  } = props;

  const [modalValue, setModalValue] = React.useState("ACH");
  const [searchText, setSearchText] = useState("");
  const [submitOpen, setSubmitOpen] = useState(false);
  const [msg, setMsg] = useState("");
  const payment_data = useSelector((state) => state.payout.payment);
  const [data, setData] = useState({
    ACH: {
      account_name: "",
      ach_routing_number: "",
      account_number: "",
      account_type: "Savings",
    },
    WIRE: {
      account_name: "",
      ach_routing_number: "",
      account_number: "",
      account_type: "Savings",
      country: "",
      city: "",
      address: "",
      postal_code: "",
    },
    SWIFT: {
      account_name: "",
      swift_bic_code: "",
      account_number: "",
      country: "",
      city: "",
      address: "",
      postal_code: "",
    },
  });

  useEffect(() => {
    updateData(modalValue, "country", country);
  }, [modalValue, country]);

  const updateData = (type, k, v) =>
    setData((prevState) => ({
      ...prevState,
      [type]: { ...prevState[type], [k]: v },
    }));
  const dispatch = useDispatch();

  const containsText = (text, searchText) =>
    text.toLowerCase().indexOf(searchText.toLowerCase()) > -1;
  const displayedOptions = useMemo(
    () =>
      contryCodeArray.filter((option) =>
        containsText(option.countryName, searchText)
      ),
    [searchText, contryCodeArray]
  );
  const handleModalChange = (event, newValue) => {
    event.preventDefault();
    setModalValue(newValue);
  };

  const BpIcon = styled("span")(({ theme }) => ({
    borderRadius: "50%",
    width: 20,
    height: 20,
    boxShadow:
      theme.palette.mode === "dark"
        ? "0 0 0 1px rgb(16 22 26 / 40%)"
        : "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
    backgroundColor: theme.palette.mode === "dark" ? "#394b59" : "#f5f8fa",
    backgroundImage:
      theme.palette.mode === "dark"
        ? "linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))"
        : "linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))",
    ".Mui-focusVisible &": {
      outline: "2px auto rgba(19,124,189,.6)",
      outlineOffset: 2,
    },
    "input:hover ~ &": {
      backgroundColor: theme.palette.mode === "dark" ? "#30404d" : "#ebf1f5",
    },
    "input:disabled ~ &": {
      boxShadow: "none",
      background:
        theme.palette.mode === "dark"
          ? "rgba(57,75,89,.5)"
          : "rgba(206,217,224,.5)",
    },
  }));

  const BpCheckedIcon = styled(BpIcon)({
    backgroundColor: "#04D9FF",
    backgroundImage:
      "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
    "&:before": {
      display: "block",
      width: 20,
      height: 20,
      backgroundImage: "radial-gradient(#fff,#fff 28%,transparent 32%)",
      content: '""',
    },
    "input:hover ~ &": {
      backgroundColor: "#106ba3",
    },
  });

  useEffect(() => {
    if (
      payment_data &&
      payment_data?.type &&
      payment_data.type === "Bank Wire"
    ) {
      if (payment_data.data.verification_type === "WIRE") {
        setModalValue("WIRE");
        setData((prevState) => ({
          ...prevState,
          WIRE: { ...payment_data.data },
        }));
      }

      if (payment_data.data.verification_type === "ACH") {
        setModalValue("ACH");
        setData((prevState) => ({
          ...prevState,
          ACH: { ...payment_data.data },
        }));
      }

      if (payment_data.data.verification_type === "SWIFT") {
        setModalValue("SWIFT");
        setData((prevState) => ({
          ...prevState,
          SWIFT: { ...payment_data.data },
        }));
      }
    }
  }, [payment_data]);

  // Pop up states
  // success/ error modal
  const [ShowPopup, setShowPopup] = useState(false);
  const [CombinedPUHead, setCombinedPUHead] = useState("");
  const [CombinedPUBody, setCombinedPUBody] = useState("");
  const [PopUpType, setPopUpType] = useState("");

  const SubmitHandleClose = () => {
    setSubmitOpen(false);
    modalClose();
  };

  const isRequiredFieldFilled = () => {
    console.log(data);
    if (modalValue === "ACH") {
      return (
        data.ACH.account_name &&
        data.ACH.ach_routing_number &&
        data.ACH.account_number &&
        data.ACH.account_type
      );
    } else if (modalValue === "WIRE") {
      return (
        data.WIRE.account_name &&
        data.WIRE.ach_routing_number &&
        data.WIRE.account_number &&
        data.WIRE.account_type &&
        data.WIRE.country &&
        data.WIRE.city &&
        data.WIRE.address &&
        data.WIRE.postal_code
      );
    } else if (modalValue === "SWIFT") {
      return (
        data.SWIFT.account_name &&
        data.SWIFT.swift_bic_code &&
        data.SWIFT.account_number &&
        data.SWIFT.country &&
        data.SWIFT.city &&
        data.SWIFT.address &&
        data.SWIFT.postal_code
      );
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!isRequiredFieldFilled()) {
      setShowPopup(true);
      setCombinedPUBody("All fields are required");
      setCombinedPUHead("Oh snap!");
      setPopUpType("error");
      return;
    }

    const payload = {
      verification_type: "Bank Wire",
      bank_wire: modalValue,
      ...data[modalValue],
    };
    console.log(payload);
    dispatch(updatePaymentVerification(payload))
      .then((res) => {
        console.log(res);
        setShowPopup(true);
        setCombinedPUHead("Woo hoo !");
        setCombinedPUBody("Submitted successfully!");
        setPopUpType("success");
        dispatch(getPayoutVerificationStatus());
      })
      .catch((err) => {
        console.log(err);
        let msg = "Failed to submit";
        if (
          err.response?.data?.message &&
          typeof err.response?.data?.message === "object"
        ) {
          msg = Object.values(err.response?.data?.message);
        }
        setShowPopup(true);
        setCombinedPUBody(msg);
        setCombinedPUHead("Oh snap!");
        setPopUpType("error");
      });
  };

  return (
    <div>
      <CombinedPopup
        type={PopUpType}
        trigger={ShowPopup}
        setTrigger={setShowPopup}
        head={CombinedPUHead}
        subhead={CombinedPUBody}
        onClick={SubmitHandleClose}
      />

      <Modal
        open={open}
        onClose={modalClose}
        className="Modal"
        sx={{ zIndex: 1 }}
      >
        <Box className="Modal-parent" gap={1} width={{ xs: "80%", md: "40%" }}>
          <Card
            className="Modal-card bankDC"
            variant="outlined"
            style={{
              maxHeight: "80vh",
            }}
          >
            <div className="title-parent">
              <Typography className="modal-title">
                Recipient’s bank details
              </Typography>
              <img
                     className="cross-button"
                src={crossIcon}
                alt="crossIcon"
                style={{ cursor: "pointer" }}
                onClick={modalClose}
              />
            </div>
            <div>
              <TabContext value={modalValue}>
                <Box
                  className="tabs-slected"
                  sx={{ borderBottom: 1, borderColor: "#ffff" }}
                >
                  <Tabs
                    variant="fullWidth"
                    textColor="#fffff"
                    indicatorColor="secondary"
                    aria-label="lab API tabs example"
                    onChange={handleModalChange}
                    value={modalValue}
                  >
                    <Tab
                      className={
                        modalValue === 1 ? "tabs-slected bankModalActive bankModal" : "ContainertabName bankModal"
                      }
                      label="ACH"
                      value="ACH"
                    />
                    <Tab
                      className={
                        modalValue === 2 ? "tabs-slected bankModal" : "ContainertabName bankModal"
                      }
                      label="WIRE"
                      value="WIRE"
                    />
                    <Tab
                      className={
                        modalValue === 3 ? "tabs-slected bankModal" : "ContainertabName bankModal"
                      }
                      label="SWIFT"
                      value="SWIFT"
                    />
                  </Tabs>
                </Box>
                <TabPanel
                  style={{ padding: "0px", marginTop: "24px" }}
                  value="ACH"
                >
                  <div style={{ marginTop: "20px" }}>
                    <Grid
                      container
                      item
                      className="gen-info-form"
                      component={"form"}
                      rowGap={3}
                    >
                      <Grid item xs={12} md={12}>
                        <div className="form-grp-in">
                          <Typography
                            htmlFor="full-name"
                            className="input-label"
                          >
                            Full name of the account holder*
                          </Typography>
                          <input
                            required
                            type="text"
                            className="input-modal"
                            id="full-name"
                            value={data.ACH.account_name}
                            onChange={(e) =>
                              updateData("ACH", "account_name", e.target.value)
                            }
                          />
                        </div>
                      </Grid>
                      <Grid item xs={12} md={12}>
                        <div className="form-grp-in">
                          <Typography
                            htmlFor="routingNumber"
                            className="input-label"
                          >
                            ACH routing number*
                          </Typography>
                          <input
                            required
                            type="text"
                            className="input-modal"
                            id="routing-number"
                            value={data.ACH.ach_routing_number}
                            onChange={(e) =>
                              updateData(
                                "ACH",
                                "ach_routing_number",
                                e.target.value
                              )
                            }
                          />
                        </div>
                      </Grid>
                      <Grid item xs={12} md={12}>
                        <div className="form-grp-in">
                          <Typography
                            htmlFor="account-number"
                            className="input-label"
                          >
                            Account Number*
                          </Typography>
                          <input
                            required
                            type="text"
                            className="input-modal"
                            id="account-number"
                            value={data.ACH.account_number}
                            onChange={(e) =>
                              updateData(
                                "ACH",
                                "account_number",
                                e.target.value
                              )
                            }
                          />
                        </div>
                      </Grid>
                      <Grid item xs={12} md={12}>
                        <div className="form-grp-in">
                          <Typography
                            htmlFor="routingNumber"
                            className="input-label"
                          >
                            Account Type
                          </Typography>
                          <FormControl>
                            <RadioGroup
                              column
                              onChange={(e) =>
                                updateData(
                                  "ACH",
                                  "account_type",
                                  e.target.value
                                )
                              }
                              value={data.ACH.account_type}
                            >
                              <FormControlLabel
                                style={{ width: "20%" }}
                                value="Savings"
                                control={
                                  <Radio
                                    checkedIcon={<BpCheckedIcon />}
                                    icon={<BpIcon />}
                                    disableRipple
                                    checked
                                  />
                                }
                                label={
                                  <span
                                    style={{
                                      fontSize: "14px",
                                      fontFamily: "Outfit",
                                      color: "#ffff",
                                    }}
                                  >
                                    {"Savings"}
                                  </span>
                                }
                              />
                              <FormControlLabel
                                style={{ width: "20%" }}
                                value="Current"
                                control={
                                  <Radio
                                    checkedIcon={<BpCheckedIcon />}
                                    icon={<BpIcon />}
                                  />
                                }
                                label={
                                  <span
                                    style={{
                                      fontSize: "14px",
                                      fontFamily: "Outfit",
                                      color: "#ffff",
                                    }}
                                  >
                                    {"Current"}
                                  </span>
                                }
                              />
                            </RadioGroup>
                          </FormControl>
                        </div>
                      </Grid>
                      <Grid item xs={12} md={12}>
                        <div className="form-grp-in">
                          <StyledFilledButton
                            type="submit"
                            onClick={handleSubmit}
                          >
                            Confirm
                          </StyledFilledButton>
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                </TabPanel>
                <TabPanel
                  style={{ padding: "0px", marginTop: "24px" }}
                  value="WIRE"
                >
                  <div style={{ marginTop: "20px" }}>
                    <Grid
                      container
                      item
                      className="gen-info-form"
                      component={"form"}
                      rowGap={3}
                    >
                      <Grid item xs={12} md={12}>
                        <div className="form-grp-in">
                          <Typography
                            htmlFor="full-name"
                            className="input-label"
                          >
                            Full name of the account holder*
                          </Typography>
                          <input
                            required
                            type="text"
                            className="input-modal"
                            id="full-name"
                            value={data.WIRE.account_name}
                            onChange={(e) =>
                              updateData("WIRE", "account_name", e.target.value)
                            }
                          />
                        </div>
                      </Grid>
                      <Grid item xs={12} md={12}>
                        <div className="form-grp-in">
                          <Typography
                            htmlFor="routingNumber"
                            className="input-label"
                          >
                            ACH routing number*
                          </Typography>
                          <input
                            required
                            type="text"
                            className="input-modal"
                            id="routing-number"
                            value={data.WIRE.ach_routing_number}
                            onChange={(e) =>
                              updateData(
                                "WIRE",
                                "ach_routing_number",
                                e.target.value
                              )
                            }
                          />
                        </div>
                      </Grid>
                      <Grid item xs={12} md={12}>
                        <div className="form-grp-in">
                          <Typography
                            htmlFor="account-number"
                            className="input-label"
                          >
                            Account Number*
                          </Typography>
                          <input
                            required
                            type="text"
                            className="input-modal"
                            id="account-number"
                            value={data.WIRE.account_number}
                            onChange={(e) =>
                              updateData(
                                "WIRE",
                                "account_number",
                                e.target.value
                              )
                            }
                          />
                        </div>
                      </Grid>
                      <Grid item xs={12} md={12}>
                        <div className="form-grp-in">
                          <Typography
                            htmlFor="accountType"
                            className="input-label"
                          >
                            Account Type
                          </Typography>
                          <FormControl>
                            <RadioGroup
                              column
                              onChange={(e) =>
                                updateData(
                                  "WIRE",
                                  "account_type",
                                  e.target.value
                                )
                              }
                              value={data.WIRE.account_type}
                            >
                              <FormControlLabel
                                style={{ width: "20%" }}
                                value="Savings"
                                control={
                                  <Radio
                                    checkedIcon={<BpCheckedIcon />}
                                    icon={<BpIcon />}
                                    disableRipple
                                    checked
                                  />
                                }
                                label={
                                  <span
                                    style={{
                                      fontSize: "14px",
                                      fontFamily: "Outfit",
                                      color: "#ffff",
                                    }}
                                  >
                                    Savings
                                  </span>
                                }
                              />
                              <FormControlLabel
                                style={{ width: "20%" }}
                                value="Current"
                                control={
                                  <Radio
                                    checkedIcon={<BpCheckedIcon />}
                                    icon={<BpIcon />}
                                  />
                                }
                                label={
                                  <span
                                    style={{
                                      fontSize: "14px",
                                      fontFamily: "Outfit",
                                      color: "#ffff",
                                    }}
                                  >
                                    Current
                                  </span>
                                }
                              />
                            </RadioGroup>
                          </FormControl>
                        </div>
                      </Grid>
                      <Grid item xs={12} md={12}>
                        <div className="form-grp-in">
                          <div className="caution-container">
                            <img
                              src={cautionIcon}
                              alt="caution"
                              width={39}
                              height={39}
                            />
                            <Typography
                              className="caution-text"
                              style={{ marginLeft: "2%" }}
                            >
                              Your recipient may be charged an additional fee by
                              their bank for incoming wire transfers. the fee
                              may vary from $12 to $20
                            </Typography>
                          </div>
                        </div>
                      </Grid>
                      <Grid item xs={12} md={12}>
                        <div className="form-grp-in">
                          <Typography
                            className="caution-text"
                            style={{ fontSize: "18px" }}
                          >
                            Recipient’s Address
                          </Typography>
                          <hr className="break-line"></hr>
                        </div>
                      </Grid>
                      <Grid item xs={12} md={12}>
                        <div className="form-grp-in">
                          <Typography
                            htmlFor="country-select"
                            className="input-label"
                          >
                            Country*
                          </Typography>
                          <Select
                            id="country-select"
                            className="form-modal-select"
                            value={country}
                            onChange={handleSelectChange}
                            MenuProps={{ autoFocus: false }}
                            labelId="search-select-label"
                            onClose={() => setSearchText("")}
                            renderValue={() => country}
                          >
                            <ListSubheader>
                              <TextField
                                size="small"
                                // Autofocus on textfield
                                autoFocus
                                placeholder="Type to search..."
                                fullWidth
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start"></InputAdornment>
                                  ),
                                }}
                                onChange={(e) => setSearchText(e.target.value)}
                                onKeyDown={(e) => {
                                  if (e.key !== "Escape") {
                                    // Prevents autoselecting item while typing (default Select behaviour)
                                    e.stopPropagation();
                                  }
                                }}
                              />
                            </ListSubheader>
                            {displayedOptions.map((country, index) => (
                              <MenuItem key={index} value={country.countryName}>
                                {country.countryName}
                              </MenuItem>
                            ))}
                          </Select>
                        </div>
                      </Grid>
                      <Grid item xs={12} md={12}>
                        <div className="form-grp-in">
                          <Typography
                            htmlFor="modalcity"
                            className="input-label"
                          >
                            City*
                          </Typography>
                          <input
                            required
                            type="text"
                            className="input-modal"
                            id="modalcity"
                            value={data.WIRE.city}
                            onChange={(e) =>
                              updateData("WIRE", "city", e.target.value)
                            }
                          />
                        </div>
                      </Grid>
                      <Grid item xs={12} md={12}>
                        <div className="form-grp-in">
                          <Typography
                            htmlFor="recipientAddress"
                            className="input-label"
                          >
                            Recipient's Address*
                          </Typography>
                          <input
                            required
                            type="text"
                            className="input-modal"
                            id="recipient-address"
                            value={data.WIRE.address}
                            onChange={(e) =>
                              updateData("WIRE", "address", e.target.value)
                            }
                          />
                        </div>
                      </Grid>
                      <Grid item xs={12} md={12}>
                        <div className="form-grp-in">
                          <Typography
                            htmlFor="postCode"
                            className="input-label"
                          >
                            Post Code*
                          </Typography>
                          <input
                            required
                            type="text"
                            className="input-modal"
                            id="post-code"
                            value={data.WIRE.postal_code}
                            onChange={(e) =>
                              updateData("WIRE", "postal_code", e.target.value)
                            }
                          />
                        </div>
                      </Grid>
                      <Grid item xs={12} md={12}>
                        <div className="form-grp-in">
                          <StyledFilledButton onClick={handleSubmit}>
                            Confirm
                          </StyledFilledButton>
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                </TabPanel>
                <TabPanel
                  style={{ padding: "0px", marginTop: "24px" }}
                  value="SWIFT"
                >
                  <div style={{ marginTop: "20px" }}>
                    <Grid
                      container
                      item
                      className="gen-info-form"
                      component={"form"}
                      rowGap={3}
                    >
                      <Grid item xs={12} md={12}>
                        <div className="form-grp-in">
                          <Typography
                            htmlFor="full-name"
                            className="input-label"
                          >
                            Full name of the account holder*
                          </Typography>
                          <input
                            required
                            type="text"
                            className="input-modal"
                            id="full-name"
                            value={data.SWIFT.account_name}
                            onChange={(e) =>
                              updateData(
                                "SWIFT",
                                "account_name",
                                e.target.value
                              )
                            }
                          />
                        </div>
                      </Grid>
                      <Grid item xs={12} md={12}>
                        <div className="form-grp-in">
                          <Typography
                            htmlFor="full-name"
                            className="input-label"
                          >
                            SWIFT / BIC Code*
                          </Typography>
                          <input
                            required
                            type="text"
                            className="input-modal"
                            id="full-name"
                            value={data.SWIFT.swift_bic_code}
                            onChange={(e) =>
                              updateData(
                                "SWIFT",
                                "swift_bic_code",
                                e.target.value
                              )
                            }
                          />
                        </div>
                      </Grid>
                      <Grid item xs={12} md={12}>
                        <div className="form-grp-in">
                          <Typography
                            htmlFor="modalaccount"
                            className="input-label"
                          >
                            IBAN / Account Number*
                          </Typography>
                          <input
                            required
                            type="text"
                            className="input-modal"
                            id="modalaccount"
                            value={data.SWIFT.account_number}
                            onChange={(e) =>
                              updateData(
                                "SWIFT",
                                "account_number",
                                e.target.value
                              )
                            }
                          />
                        </div>
                      </Grid>
                      <Grid item xs={12} md={12}>
                        <div className="form-grp-in">
                          <Typography
                            className="caution-text"
                            style={{ fontSize: "18px" }}
                          >
                            Recipient’s Address
                          </Typography>
                          <hr className="break-line"></hr>
                        </div>
                      </Grid>
                      <Grid item xs={12} md={12}>
                        <div className="form-grp-in">
                          <Typography
                            htmlFor="country-select"
                            className="input-label"
                          >
                            Country*
                          </Typography>
                          <Select
                            id="country-select"
                            className="form-modal-select"
                            value={country}
                            onChange={handleSelectChange}
                            MenuProps={{ autoFocus: false }}
                            labelId="search-select-label"
                            onClose={() => setSearchText("")}
                            renderValue={() => country}
                          >
                            <ListSubheader>
                              <TextField
                                size="small"
                                // Autofocus on textfield
                                autoFocus
                                placeholder="Type to search..."
                                fullWidth
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start"></InputAdornment>
                                  ),
                                }}
                                onChange={(e) => setSearchText(e.target.value)}
                                onKeyDown={(e) => {
                                  if (e.key !== "Escape") {
                                    // Prevents autoselecting item while typing (default Select behaviour)
                                    e.stopPropagation();
                                  }
                                }}
                              />
                            </ListSubheader>
                            {displayedOptions.map((country, index) => (
                              <MenuItem key={index} value={country.countryName}>
                                {country.countryName}
                              </MenuItem>
                            ))}
                          </Select>
                        </div>
                      </Grid>
                      <Grid item xs={12} md={12}>
                        <div className="form-grp-in">
                          <Typography
                            htmlFor="modalcity"
                            className="input-label"
                          >
                            City*
                          </Typography>
                          <input
                            required
                            type="text"
                            className="input-modal"
                            id="modalcity"
                            value={data.SWIFT.city}
                            onChange={(e) =>
                              updateData("SWIFT", "city", e.target.value)
                            }
                          />
                        </div>
                      </Grid>
                      <Grid item xs={12} md={12}>
                        <div className="form-grp-in">
                          <Typography
                            htmlFor="recipientAddress"
                            className="input-label"
                          >
                            Recipient's Address*
                          </Typography>
                          <input
                            required
                            type="text"
                            className="input-modal"
                            id="recipient-address"
                            value={data.SWIFT.address}
                            onChange={(e) =>
                              updateData("SWIFT", "address", e.target.value)
                            }
                          />
                        </div>
                      </Grid>
                      <Grid item xs={12} md={12}>
                        <div className="form-grp-in">
                          <Typography
                            htmlFor="postCode"
                            className="input-label"
                          >
                            Post Code*
                          </Typography>
                          <input
                            required
                            type="text"
                            className="input-modal"
                            id="post-code"
                            value={data.SWIFT.postal_code}
                            onChange={(e) =>
                              updateData("SWIFT", "postal_code", e.target.value)
                            }
                          />
                        </div>
                      </Grid>
                      <Grid item xs={12} md={12}>
                        <div className="form-grp-in">
                          <StyledFilledButton onClick={handleSubmit}>
                            Confirm
                          </StyledFilledButton>
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                </TabPanel>
              </TabContext>
            </div>
          </Card>
        </Box>
      </Modal>
    </div>
  );
};

export default BankWireModal;
